import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import authServices from '@src/services/auth.services';
import { PURGE } from 'redux-persist';
import { setAuthorization } from '@src/services/api';
import dayjs from 'dayjs';
import takeRight from 'lodash/takeRight';
import concat from 'lodash/concat';

export const login = createAsyncThunk('login', async (body, { rejectWithValue }) => {
  try {
    return await authServices.login(body);
  } catch (error) {
    return rejectWithValue(error?.data);
  }
});

export const loginAdmin = createAsyncThunk('loginAdmin', async (body, { rejectWithValue }) => {
  try {
    return await authServices.loginAdmin(body);
  } catch (error) {
    return rejectWithValue(error?.data);
  }
});

export const migrationOtp = createAsyncThunk('migrationOtp', async (body, { rejectWithValue }) => {
  try {
    return await authServices.migrationOtp(body);
  } catch (error) {
    return rejectWithValue(error?.data);
  }
});

export const loginOtp = createAsyncThunk(
  'loginOtp',
  async (body, { getState, rejectWithValue }) => {
    try {
      const mobileLoginId = await getState()?.auth.mobileLoginId;
      const migrationId = await getState()?.auth.MigrationId;
      const mobileLoginIds = await getState()?.auth.mobileLoginIds;
      const idLastTwoItems = takeRight(mobileLoginIds, 2);
      const ids = idLastTwoItems.filter((item) => !!item);

      if (!migrationId) {
        if (!mobileLoginId) {
          return rejectWithValue('Lütfen önce giriş yapınız.');
        }
      }

      return await authServices.loginOtp({
        ...body,
        mobileLoginId: ids,
        ...(migrationId ? { migrationId } : {}),
      });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const reSendOtpSms = createAsyncThunk(
  'reSendOtpSms',
  async (body, { getState, rejectWithValue }) => {
    try {
      const mobileLoginId = await getState()?.auth.mobileLoginId;
      const MigrationId = await getState()?.auth?.MigrationId;
      if (!MigrationId) {
        if (!mobileLoginId) {
          return rejectWithValue('Lütfen önce giriş yapınız.');
        }
      }
      return await authServices.reSendOtpSms({
        mobileLoginId: mobileLoginId,
        ...(MigrationId ? { MigrationId } : {}),
      });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const forgotPasswordChange = createAsyncThunk(
  'forgotPasswordChange',
  async (body, { rejectWithValue }) => {
    try {
      return await authServices.forgotPasswordChange(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);
export const forgotPasswordChangeAdmin = createAsyncThunk(
  'forgotPasswordChangeAdmin',
  async (body, { rejectWithValue }) => {
    try {
      return await authServices.forgotPasswordChangeAdmin(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const forgotPassword = createAsyncThunk(
  'forgotPassword',
  async (body, { rejectWithValue }) => {
    try {
      return await authServices.forgotPassword(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const forgotPasswordAdmin = createAsyncThunk(
  'forgotPasswordAdmin',
  async (body, { rejectWithValue }) => {
    try {
      return await authServices.forgotPasswordAdmin(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const changeUserPassword = createAsyncThunk(
  'changeUserPassword',
  async (body, { rejectWithValue }) => {
    try {
      return await authServices.changeUserPassword(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const forgottenPasswordTokenCheck = createAsyncThunk(
  'forgottenPasswordTokenCheck',
  async (body, { rejectWithValue }) => {
    try {
      return await authServices.forgottenPasswordTokenCheck(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);
export const forgottenPasswordTokenCheckAdmin = createAsyncThunk(
  'forgottenPasswordTokenCheckAdmin',
  async (body, { rejectWithValue }) => {
    try {
      return await authServices.forgottenPasswordTokenCheckAdmin(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const logout = createAsyncThunk('logout', async (body, { rejectWithValue }) => {
  try {
    await authServices.logout();
  } catch (error) {
    rejectWithValue(error?.data);
  }
});

export const loginUserWithoutPassword = createAsyncThunk(
  'admin/loginUserWithoutPassword',
  async (body, { rejectWithValue }) => {
    try {
      return await authServices.loginUserWithoutPassword(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const continueRefreshToken = createAsyncThunk(
  'refreshToken',
  async (body, { getState, rejectWithValue }) => {
    try {
      return await authServices.refreshToken({
        refreshToken: body,
      });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const loginOtpDisable = createAsyncThunk(
  'loginOtpDisable',
  async (body, { getState, rejectWithValue }) => {
    try {
      return await authServices.loginOtpDisable({
        ...body,
      });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const loginOtpExclude = createAsyncThunk(
  'loginOtpExclude',
  async (body, { getState, rejectWithValue }) => {
    try {
      return await authServices.loginOtpExclude({
        ...body,
      });
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  isAdmin: false,
  MigrationId: null,
  token: null,
  refreshToken: null,
  accessToken: null,
  adminToken: null, //Admin => Kullanıcı ile gir geçişi sırasında admin tokenını yedeklemek için kullanılacak
  msisdn: null,
  mobileLoginId: null,
  mobileLoginIds: [],
  authority: [],
  expirationTime: null,
  loginTime: null,
  loginWithOutRefreshToken: false,
  isBpCustomer: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    removeToken: (state) => {
      state.isAdmin = false;
      state.token = null;
      state.refreshToken = null;
      state.msisdn = null;
      state.mobileLoginId = null;
      state.adminToken = null;
      state.authority = [];
    },
    setDoLogin: (state, action) => {
      localStorage.setItem('persist:crossTabs', 'false');
      state.adminToken = state.token;
      state.token = action?.payload;
      state.isAdmin = false;
      state.msisdn = null;
      state.mobileLoginId = null;
      state.mobileLoginIds = [];
      state.authority = ['dashboard'];
    },
    setDoLoginRevert: (state, action) => {
      localStorage.setItem('persist:crossTabs', 'true');
      state.token = action?.payload;
      state.adminToken = null;
      state.isAdmin = true;
    },
    setMigrationId: (state, action) => {
      state.MigrationId = action?.payload;
    },
    setIsBpCustomer: (state, action) => {
      state.isBpCustomer = action?.payload;
    },
    setIsSchool: (state, action) => {
      state.isSchool = action?.payload;
    },
    //alttakiler bomboş fonksiyon. sırf testten geçsin diye. neden yapılmış dev e atılmış bilgim yok.
    setUserName: (state, action) => {
      state.userName = action?.payload;
    },
    setUserEmail: (state, action) => {
      state.userEmail = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.fulfilled, (state, action) => {
      state.msisdn = action?.payload?.data?.msisdn;
      state.mobileLoginId = action?.payload?.data?.token;
      state.adminToken = null;
      state.mobileLoginIds = concat(state.mobileLoginIds, [action?.payload?.data?.token]);
      state.isAdmin = false;
    });
    builder.addCase(migrationOtp.fulfilled, (state, action) => {
      state.msisdn = action?.payload?.data?.msisdn;
      state.mobileLoginId = action?.payload?.data?.token;
      state.mobileLoginIds = concat(state.mobileLoginIds, [action?.payload?.data?.token]);
      state.MigrationId = null;
      state.adminToken = null;
      state.isAdmin = false;
    });
    builder.addCase(loginAdmin.fulfilled, (state, action) => {
      state.msisdn = action?.payload?.data?.msisdn;
      state.mobileLoginId = action?.payload?.data?.token;
      state.mobileLoginIds = concat(state.mobileLoginIds, [action?.payload?.data?.token]);
      state.adminToken = null;
      state.isAdmin = true;
    });
    builder.addCase(loginOtpDisable.fulfilled, (state, action) => {
      updateLoginState(state, action.payload);
    });
    builder.addCase(loginOtpExclude.fulfilled, (state, action) => {
      updateLoginState(state, action.payload);
    });

    builder.addCase(loginOtp.fulfilled, (state, action) => {
      updateLoginState(state, action.payload);
    });
    builder.addCase(continueRefreshToken.fulfilled, (state, action) => {
      state.refreshToken = action?.payload?.data?.refreshToken;
      state.accessToken = action?.payload?.data?.accessToken;
      state.token = action?.payload?.data?.accessToken;
      state.loginWithOutRefreshToken = false;
      state.loginTime = new Date().toISOString();
      localStorage.setItem('login:time', new Date().getTime().toString());
      setAuthorization(`Bearer ${action?.payload?.data?.accessToken}`);
    });
    builder.addCase(forgotPasswordChange.fulfilled, (state, action) => {
      state.msisdn = action?.payload?.data?.msisdn;
      state.mobileLoginId = action?.payload?.data?.token;
      state.mobileLoginIds = concat(state.mobileLoginIds, [action?.payload?.data?.token]);
    });
    builder.addCase(forgotPasswordChangeAdmin.fulfilled, (state, action) => {
      state.msisdn = action?.payload?.data?.msisdn;
      state.mobileLoginId = action?.payload?.data?.token;
      state.mobileLoginIds = concat(state.mobileLoginIds, [action?.payload?.data?.token]);
    });
    builder.addCase(logout.fulfilled, (state, action) => {
      state.token = null;
      state.refreshToken = null;
      state.msisdn = null;
      state.mobileLoginId = null;
      state.adminToken = null;
      state.mobileLoginIds = [];
      state.authority = [];
      state.expirationTime = null;
      state.loginTime = null;
      state.loginWithOutRefreshToken = false;
      setAuthorization(``);
      localStorage.setItem('login:time', '0');
      localStorage.setItem('faceValue', 0);
    });
    builder.addCase(logout.rejected, (state) => {
      state.token = null;
      state.refreshToken = null;
      state.msisdn = null;
      state.mobileLoginId = null;
      state.mobileLoginIds = [];
      state.authority = [];
      state.expirationTime = null;
      state.loginTime = null;
      state.loginWithOutRefreshToken = false;
      setAuthorization(``);
      localStorage.setItem('login:time', '0');
      localStorage.setItem('faceValue', 0);
    });
    builder.addCase(PURGE, () => {
      localStorage.setItem('persist:crossTabs', 'true');
      return { ...initialState };
    });
  },
});

const updateLoginState = (state, payload) => {
  localStorage.setItem('persist:crossTabs', 'false');
  state.token = payload?.data?.token;
  state.refreshToken = payload?.data?.refreshToken;
  state.isBpCustomer = payload?.data?.isBpCustomer || false;
  state.isSchool = payload?.data?.isSchool || false;
  state.msisdn = null;
  state.mobileLoginId = null;
  state.mobileLoginIds = [];
  state.MigrationId = null;
  state.authority = ['dashboard'];
  state.expirationTime = dayjs().add(2, 'hours').toISOString();
  state.loginTime = dayjs().toISOString();
  state.loginWithOutRefreshToken = true;
  localStorage.setItem('login:time', new Date().getTime().toString());
  setAuthorization(`Bearer ${payload?.data?.token}`);
};

export const {
  setMigrationId,
  removeToken,
  setDoLogin,
  setDoLoginRevert,
  setIsBpCustomer,
  setUserName,
  setUserEmail,
  setIsSchool,
} = authSlice.actions;
